import { createAction } from '@reduxjs/toolkit';
import { RequestError } from 'types';
import { State, Callback } from './types';

export const fetchPofiles = createAction('profiles/fetch', (callback?: Callback<unknown, void>) => ({
  payload: undefined,
  meta: { callback },
}));

export const fetchedProfiles = createAction('profiles/fetched', (data?: State['data'], error?: RequestError) => ({
  payload: error || data,
  error: Boolean(error),
}));

export default {
  fetchedProfiles,
  fetchPofiles,
};
